import { useQuery } from '@tanstack/react-query';

import api from 'api';
import type { AccountResponse } from 'api/resources/accounts/types';
import useProjectRoute from './useProjectRoute';
import useSampleProject from './useSampleProjects/useSampleProject';

export const getAccountQueryKey = (accountId: string) => [accountId, 'account'];

const useAccount = () => {
  const { accountId } = useProjectRoute();
  const { inSampleProject } = useSampleProject();

  const {
    data: account,
    isLoading,
    isError,
  } = useQuery<AccountResponse, Error>(
    getAccountQueryKey(accountId),
    () => api.getAccount(accountId),
    {
      retry: false,
      enabled: !inSampleProject && !!accountId,
    },
  );

  return {
    accountId,
    account,
    isLoading,
    isError,
  };
};

export default useAccount;
